var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.userEmail)?_c('iframe',{staticClass:"chat-frame__wrapper",attrs:{"allowfullscreen":"true","src":_vm.url}}):_c('v-alert',{staticStyle:{"margin-top":"-2px","width":"100%"},attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.$t('email_not_found'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a40ce414","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/livechat/Warroom/ChatIframe.vue
// module id = null
// module chunks = 